<template>

  <div>

    <v-data-table
      id="serviceAreaTable"
      v-model="localSelected"
      :headers="headers"
      :items="items"

      :sort-by="sortBy"
      :sort-desc="sortDesc"
      must-sort

      :hide-default-footer="hideDefaultFooter"
      :dense="dense"
      :search="search"
      :fixed-header="true"
      :disable-pagination="disablePagination"

      :loading="loadingServiceAreas"

      @update:sort-by="handleSort"
      @update:sort-desc="handleSortDesc"
    >

      <slot></slot>

      <template v-slot:top="{ items, pagination, options }" v-if="showFilters">

        <v-layout class="ma-2">

          <v-flex xs3>

            <v-menu
              :close-on-content-click="false"
              :nudge-width="200"
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  color="grey lighten-3"
                  :ripple="false"
                  depressed
                  v-on="on"
                >
                  Filter by Speed
                </v-btn>
              </template>

              <Speed table-name="serviceAreas"
                     field-name="Speeds_mbps"></Speed>

            </v-menu>

          </v-flex>

          <v-spacer></v-spacer>

          <v-flex xs5>

            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              label="Enter phrase for basic search"
              hide-details
              clearable

            ></v-text-field>
          </v-flex>

        </v-layout>

      </template>

      <template v-slot:item="{ item, select, isSelected, expand, isExpanded, headers }">

        <tr :class="isHighlighted(item, headers) ? 'blue lighten-5' : ''"
            @click="handleRowClick(item)"
        >

          <td v-if="headers.some(i => i.value === 'isRecommended')" class="text-center">
            <v-icon v-if="item.properties.Speeds_mbps >= speedPreference" color="info"
                    class="text-center">
              mdi-star-circle
            </v-icon>
          </td>

          <td v-if="headers.some(i => i.value === 'isSelected')" class="text-center">
            <div class="text-center">
              <v-icon v-if="feature && feature.id === item.id" color="blue">
                <!--          mdi-check-circle-->
                mdi-checkbox-marked-circle-outline
              </v-icon>
              <!--              <v-icon v-else color="grey lighten-3">-->
              <!--                mdi-checkbox-blank-circle-outline-->
              <!--              </v-icon>-->
            </div>
          </td>

          <template v-for="(header, key) in headers">
            <td
              v-if="header.value.includes('properties') && header.value !== 'properties.Speeds_mbps'"
              :class="['properties.Type'].includes(header.value) ? 'text-center' : ''"
              :key="key">
              {{item.properties[header.value.split('.')[1]]}}
            </td>
            <td v-if="header.value === 'properties.Speeds_mbps'" :key="key" class="text-center">
              <SpeedTableCell :value="item.properties.Speeds_mbps"></SpeedTableCell>
            </td>
          </template>

        </tr>

      </template>

    </v-data-table>

  </div>

</template>

<script>
import debounce from 'lodash/debounce';

import SpeedTableCell from '../SpeedTableCell';
import Speed from '@/components/filters/Speed';

import {
  blacklistedFields,
  serviceAreasAlts as alternateHeaders
} from '../../helpers/models/table.columns';

export default {

  name: 'ServiceAreasTable',
  components: { SpeedTableCell, Speed },
  props: {

    customHeaders: {
      type: Array,
      required: false,
      default: () => [],
    },

    blacklist: {
      type: Array,
      required: false,
      default: null,
    },

    showSelections: {
      type: Boolean,
      default: true,
    },

    showFilters: {
      type: Boolean,
      default: false,
    },

    showAlternateHeaders: {
      type: Boolean,
      default: false,
    },

    items: {
      type: Array,
      required: true,
    },

    dense: {
      type: Boolean,
      required: false,
      default: true,
    },

    disablePagination: {
      type: Boolean,
      required: false,
      default: false,
    },

    hideDefaultFooter: {
      type: Boolean,
      required: false,
      default: false,
    },

    search: {
      type: String,
      required: false,
      default: '',
    },

    sortBy: {
      type: String,
      required: false,
    },

    sortDesc: {
      type: Boolean,
      required: false,
    },

  },

  data() {
    return {
      localSelected: [],
      alternateHeaders,
    };
  },

  computed: {

    loadingServiceAreas() {
      return !this.$store.state.ui.loadingServiceAreas;
    },

    feature() {
      return this.$store.getters.selectedService;
    },

    headers() {
      let headers = [...this.$helpers.tables.tableColumns.serviceAreas];

      if (this.showSelections) {
        headers.unshift({
          text: null,
          value: 'isSelected',
          align: 'center',
          sortable: false,
          divider: false,
          class: null,
          width: 25,
        });
      }

      this.customHeaders.forEach(item => {
        if (item.index !== null || item.index !== undefined) {
          headers.splice(item.index, 0, item);
        }
      });

      if (this.blacklist) {
        return headers.filter(item => !this.blacklist.includes(item.value));
      }

      return headers;
    },

    speedPreference() {
      return this.$store.getters.speedPreference;
    },

  },

  methods: {

    handleRowClick(feature) {
      console.log('handleRowClick');
      this.$emit('row-clicked', feature);
    },

    handleSort(sort) {
      console.log('handleSort');
      this.$router.push({
        query: {
          ...this.$route.query,
          sort,
        },
      });
    },

    handleSortDesc(desc) {
      console.log('handleSortDesc');
      this.$router.push({
        query: {
          ...this.$route.query,
          desc,
        },
      });
    },

    isHighlighted(item, headers) {
      const isSelected = this.feature && this.feature.id === item.id
        && headers.map(i => i.value).includes('isSelected');

      const isRecommended = item.properties.Speeds_mbps >= this.speedPreference
        && headers.map(i => i.value).includes('isRecommended');

      return isSelected || isRecommended;
    }

  },

};
</script>

<style lang="scss">

  #serviceAreaTable.v-data-table {

    tr {
      cursor: pointer;
    }

    td {
      font-size: 8pt;
    }

    /*tr:nth-child(even) {*/
    /*  background-color: whitesmoke;*/
    /*}*/

  }

</style>
